import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { RmaStatus } from '../types';
import { RMA_STATUS_LABELS } from '../types';

interface RmaStatusBadgeProps {
  status: RmaStatus;
  className?: string;
}

const statusColors: Record<RmaStatus, string> = {
  draft: 'bg-gray-100 text-gray-800 border-gray-300',
  label_generated: 'bg-blue-100 text-blue-800 border-blue-300',
  shipped: 'bg-amber-100 text-amber-800 border-amber-300',
  received: 'bg-purple-100 text-purple-800 border-purple-300',
  inspecting: 'bg-orange-100 text-orange-800 border-orange-300',
  resolved: 'bg-green-100 text-green-800 border-green-300',
  closed: 'bg-gray-100 text-gray-600 border-gray-300',
};

export function RmaStatusBadge({ status, className }: RmaStatusBadgeProps) {
  const { t } = useTranslation('operations');
  const label = t(`rma.status.${status}`, RMA_STATUS_LABELS[status] || status);
  const colorClass = statusColors[status] || 'bg-gray-100 text-gray-800 border-gray-300';

  return (
    <Badge variant="outline" className={`${colorClass} ${className || ''}`}>
      {label}
    </Badge>
  );
}
